import React, { useEffect, useState } from 'react'
import { REFRESH_TYPES } from 'tennders-common/stores/socket/action'
import useMap from 'tennders-transactions/hooks/useMap'
import useSocket from 'tennders-common/hooks/useSocket'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import useTransactionDetailStore from 'tennders-transactions/stores/useTransactionDetailStore'
import { motion } from 'framer-motion'

const initial = { right: '-110%' }
const animate = { right: 0 }
const transition = { duration: 0.3 }
const styles = { zIndex: 2000 }

const LayoutDetail = ({ header, id, children }) => {
  const { refresh } = useSocket()
  const { refreshTransaction } = useTransactions()
  const clearTransactionDetail = useTransactionDetailStore(store => store.setDetail)
  const { resetMap } = useMap()
  const { resetOffer } = useOffer()
  const [setAssignTruckLoadType] = useTransactionDetailStore(state => [state.setAssignTruckLoadType])
  const [animationCompleted, setAnimationCompleted] = useState(false)
  useEffect(() => {
    if (id) {
      document.querySelector('body').classList.add('body-no-scroll')
    } else {
      resetOffer()
      resetMap()
      setAssignTruckLoadType(false)
      document.querySelector('body').classList.remove('body-no-scroll')
    }
  }, [id])

  useEffect(() => {
    if (refresh === `${REFRESH_TYPES.TRANSACTION}-${id}`) {
      refreshTransaction()
    }
  }, [refresh])

  return (
    <motion.div
      onAnimationComplete={(data) => {
        setAnimationCompleted(data.right === 0)
        if (data.right === '-110%') {
          setTimeout(() => {
            clearTransactionDetail(false, null)
          }, 1500)
        }
      }}
      style={styles}
      initial={initial}
      animate={id ? animate : null}
      transition={transition}
      className="tennders-big-slide-panel-right tennders-right-panel-choosen-route"
    >
      {header}
      {animationCompleted ? children : null}
    </motion.div>
  )
}

export default React.memo(LayoutDetail)
